import { render, staticRenderFns } from "./DialogWindow.vue?vue&type=template&id=31b69da4&"
import script from "./DialogWindow.vue?vue&type=script&lang=js&"
export * from "./DialogWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports